import React from "react";
import { motion } from "framer-motion";

const stats = [
    { value: "15+", label: "Years in practice" },
    { value: "50+", label: "Brands shaped" },
    { value: "2", label: "Studio cities" },
    { value: "23+", label: "Active clients" },
];

const clients = [
    "Spiritual Cradle",
    "Just Naturals Wellness Resorts",
    "Tenacious Honey",
    "Celeste Artisanal Teas",
    "SilverSea Products & Interiors",
    "Dark Tourism",
    "One Knot One",
    "NSquare Events",
    "Impact Investors Council",
    "+ 20 more",
];

const ProofBar = () => {
    return (
        <section
            data-testid="proof-section"
            className="section-dark relative z-10 py-24 lg:py-32"
        >
            <div className="st-container">
                <p className="eyebrow text-[var(--st-gold)] mb-12">02 — In numbers, and in names</p>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6 mb-20">
                    {stats.map((s, i) => (
                        <motion.div
                            key={s.label}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7, delay: i * 0.1 }}
                            data-testid={`stat-${i}`}
                        >
                            <div className="stat-number text-[var(--st-gold)]">{s.value}</div>
                            <hr className="thin my-4 w-12 border-[var(--st-gold)]" />
                            <p className="text-sm uppercase tracking-widest text-[#c8c5b3]">{s.label}</p>
                        </motion.div>
                    ))}
                </div>

                <div className="flex flex-wrap gap-x-3 gap-y-3 items-center">
                    {clients.map((c) => (
                        <span
                            key={c}
                            className="inline-block px-4 py-2 border border-[rgba(235,233,222,0.25)] text-xs uppercase tracking-widest hover:border-[var(--st-gold)] hover:text-[var(--st-gold)] transition-colors"
                            data-testid={`client-pill-${c.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                        >
                            {c}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProofBar;
